import { login } from '@/api/auth';
import { getUser, changeUserInfo } from '@/api/user';
import { handleError } from "@/utils/common";

import VueCookies from "vue-cookies";

const userStore = {
	namespaced: true,
	state: {
		user: {},
		userId: VueCookies.get("userId") || "",
		ndbTkn: VueCookies.get("ndbTkn") || "",
		grade: VueCookies.get("grade") || "GUEST",
		assnYn: VueCookies.get("assnYn") || "",
		certExpiredYn: "N",
	},
	getters: {
		isLogin(state) {
			return state.ndbTkn !== "";
		},
		isGuest(state) {
			return state.ndbTkn !== "" && state.grade === "GUEST";
		},
		isAssn(state) {
			return state.assnYn === "Y";
		},
		isCertExpired(state) {
			return state.certExpiredYn === "Y";
		},
		getId(state) {
			return state.userId;
		},
		getGrade(state) {
			return state.grade;
		},
		getNdbTkn(state) {
			return state.ndbTkn;
		},
		getUserNm(state) {
			return state.user.userNm;
		},
		getUserEmail(state) {
			return state.user.email;
		},
		getUserCell(state) {
			return state.user.cell;
		},
		getUserDept(state) {
			return state.user.dept;
		},
	},
	mutations: {
		SET_USER(state, user) {
			state.user = user;
		},
		SET_USER_ID(state, userId) {
			state.userId = userId;
		},
		SET_NDB_TKN(state, ndbTkn) {
			state.ndbTkn = ndbTkn;
		},
		SET_GRADE(state, grade) {
			state.grade = grade;
		},
		SET_ASSN_YN(state, assnYn) {
			state.assnYn = assnYn;
		},
		SET_CERT_EXPIRED_YN(state, certExpiredYn) {
			state.certExpiredYn = certExpiredYn;
		},
		CLEAR_ALL(state) {
			state.user = {};
			state.userId = "";
			state.ndbTkn = "";
			state.grade = "";
			state.assnYn = "";
			state.certExpiredYn = "N";
		},
	},
	actions: {
		async FETCH_USER({ state, commit }) {
			if (Object.keys(state.user).length === 0) {
				try {
					const param = {
						userId: state.userId,
					};
					const { data } = await getUser(param);
					commit("SET_USER", data.data);
				} catch (error) {
					handleError(error);
				}
			}
		},
		async SET_USER({ commit }, userInfo) {
			commit("SET_USER", userInfo);
		},
		async LOGIN({ commit }, loginUserData) {
			const { data } = await login(loginUserData);
			commit("SET_USER", data.data.user);
			commit("SET_USER_ID", data.data.id);
			commit("SET_NDB_TKN", data.data.ndbTkn);
			commit("SET_GRADE", data.data.grade);
			commit("SET_ASSN_YN", data.data.assnYn);
			commit("SET_CERT_EXPIRED_YN", data.data.certExpiredYn);
			VueCookies.set("userId", data.data.id);
			VueCookies.set("ndbTkn", data.data.ndbTkn);
			VueCookies.set("grade", data.data.grade);
			VueCookies.set("assnYn", data.data.assnYn);
		},
		LOGOUT({ commit }) {
			commit("CLEAR_ALL");
			VueCookies.remove("userId");
			VueCookies.remove("ndbTkn");
			VueCookies.remove("grade");
			VueCookies.remove("assnYn");
		},
		REFRESH_USER({ commit }, data) {
			commit("SET_NDB_TKN", data.data.ndbTkn);
			VueCookies.set("ndbTkn", data.data.ndbTkn);
		},
		async CHANGE_USER_INFO({ commit }, param) {
			const { data } = await changeUserInfo(param);
			commit("SET_USER", data.data);
		}
	},
};

export default userStore;
